module.exports = __webpack_public_path__ + "static/50invgde-f3b335b02f8b75b8bebe54863ba363c4.gif";